var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "handle-box" },
        [
          _c(
            "el-form",
            {
              ref: "queryCondition",
              staticClass: "searchForm",
              attrs: { model: _vm.queryCondition, "label-width": "120px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "生产日期从" } },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      "value-format": "yyyy-MM-dd",
                                      type: "date",
                                      placeholder: _vm.$t("common.selDate"),
                                    },
                                    model: {
                                      value:
                                        _vm.queryCondition.parentBatchNoFrom,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "parentBatchNoFrom",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryCondition.parentBatchNoFrom",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "生产日期至" } },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      "value-format": "yyyy-MM-dd",
                                      type: "date",
                                      placeholder: _vm.$t("common.selDate"),
                                    },
                                    model: {
                                      value: _vm.queryCondition.parentBatchNoTo,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "parentBatchNoTo",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryCondition.parentBatchNoTo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "小批次数量" } },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.subBatchNumber,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "subBatchNumber",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryCondition.subBatchNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "GRI编码" } },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.griCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "griCode",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.griCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-collapse-transition",
                    [
                      _vm.isShow
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "GRI名称" } },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "100%" },
                                            attrs: { clearable: "" },
                                            model: {
                                              value: _vm.queryCondition.griName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "griName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.griName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "ASL" } },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "100%" },
                                            attrs: { clearable: "" },
                                            model: {
                                              value: _vm.queryCondition.aslName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "aslName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.aslName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "供应商" } },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "100%" },
                                            attrs: { clearable: "" },
                                            model: {
                                              value:
                                                _vm.queryCondition.supplierName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "supplierName",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.supplierName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "工厂" } },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "100%" },
                                            attrs: { clearable: "" },
                                            model: {
                                              value:
                                                _vm.queryCondition.plantName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "plantName",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.plantName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "状态" } },
                                        [
                                          _c("ic-select", {
                                            staticClass: "handle-input",
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              table: "TT_PROC_RECORD",
                                              field: "STATUS",
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.queryCondition.status,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.status",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center", align: "middle" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.queryData },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.search")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.restQueryForm },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.reset")))]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "arrowDown",
                      on: {
                        click: function ($event) {
                          _vm.isShow = !_vm.isShow
                        },
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                      _c("i", {
                        class: _vm.isShow
                          ? "el-icon-arrow-up iconBtn"
                          : "el-icon-arrow-down iconBtn",
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "action-btn-row" },
        [
          _vm.isSupplier
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.PROC_BATCH_RECORD_ADD,
                      expression: "PROC_BATCH_RECORD_ADD",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.addRecord },
                },
                [_vm._v("新增")]
              )
            : _vm._e(),
          _vm.isSupplier
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.PROC_BATCH_RECORD_ADD,
                      expression: "PROC_BATCH_RECORD_ADD",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.doBatchImport },
                },
                [_vm._v("批量导入")]
              )
            : _vm._e(),
          _vm.isSupplier
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.PROC_BATCH_RECORD_ADD,
                      expression: "PROC_BATCH_RECORD_ADD",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.doBatchSubmit },
                },
                [_vm._v("批量提交")]
              )
            : _vm._e(),
          _vm.isSupplier
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.PROC_BATCH_RECORD_ADD,
                      expression: "PROC_BATCH_RECORD_ADD",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.doVoid },
                },
                [_vm._v("作废")]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "acl",
                  rawName: "v-acl",
                  value: _vm.PROC_BATCH_RECORD_EXPORT,
                  expression: "PROC_BATCH_RECORD_EXPORT",
                },
              ],
              staticClass: "btn",
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.exportData },
            },
            [_vm._v("导出数据")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "max-height": "425",
            border: "",
            stripe: "",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", {
            attrs: {
              prop: "parentBatchNo",
              sortable: "",
              "sort-method": (a, b) =>
                _vm.sortByDateTime(a, b, "parentBatchNo"),
              label: "生产日期",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "a-link",
                        on: {
                          click: function ($event) {
                            return _vm.viewDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.parentBatchNo))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "subBatchNumber",
              sortable: "",
              "sort-method": (a, b) => _vm.sortMethods(a, b, "subBatchNumber"),
              label: "小批次数量",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "version",
              sortable: "",
              "sort-method": (a, b) => _vm.sortMethods(a, b, "version"),
              label: "版本号",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "griCode",
              sortable: "",
              "sort-method": (a, b) => _vm.sortMethods(a, b, "griCode"),
              label: "GRI编码",
              "min-width": "130",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "griName",
              sortable: "",
              "sort-method": (a, b) => _vm.sortMethods(a, b, "griName"),
              label: "GRI名称",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "aslName",
              sortable: "",
              "sort-method": (a, b) => _vm.sortMethods(a, b, "aslName"),
              label: "ASL",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "category1",
              sortable: "",
              "sort-method": (a, b) => _vm.sortMethods(a, b, "category1"),
              label: "Category1",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "category2",
              sortable: "",
              "sort-method": (a, b) => _vm.sortMethods(a, b, "category2"),
              label: "Category2",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "category3",
              sortable: "",
              "sort-method": (a, b) => _vm.sortMethods(a, b, "category3"),
              label: "Category3",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "supplierName",
              sortable: "",
              "sort-method": (a, b) => _vm.sortMethods(a, b, "supplierName"),
              label: "供应商",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "plantName",
              sortable: "",
              "sort-method": (a, b) => _vm.sortMethods(a, b, "plantName"),
              label: "工厂",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "processNumber",
              sortable: "",
              "sort-method": (a, b) => _vm.sortMethods(a, b, "processNumber"),
              label: "制成总数",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "factorsAbnormal",
              sortable: "",
              "sort-method": (a, b) => _vm.sortMethods(a, b, "factorsAbnormal"),
              label: "是否存在偏离指标",
              "min-width": "140",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(scope.row.factorsAbnormal ? "是" : "否") +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              sortable: "",
              "sort-method": (a, b) => _vm.sortMethods(a, b, "status"),
              label: "状态",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type:
                            scope.row.status === "DRAFT"
                              ? "info"
                              : scope.row.status === "SUBMITTED"
                              ? "success"
                              : "danger",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.status === "DRAFT"
                                ? "草稿"
                                : scope.row.status === "SUBMITTED"
                                ? "已提交"
                                : "已作废"
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "writeCompleted",
              sortable: "",
              "sort-method": (a, b) => _vm.sortMethods(a, b, "writeCompleted"),
              label: "是否填写完整",
              "min-width": "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " + _vm._s(scope.row.writeCompleted ? "是" : "否") + " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "updateDate",
              sortable: "",
              "sort-method": (a, b) => _vm.sortMethods(a, b, "updateDate"),
              label: "更新时间",
              "min-width": "140",
              "show-overflow-tooltip": "",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryCondition.pageNum,
              "page-sizes": _vm.pageSizeList,
              "page-size": _vm.queryCondition.pageSize,
              layout: _vm.pageLayout,
              total: _vm.total,
              "page-count": _vm.pages,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择制造过程模板",
            visible: _vm.dialogVisible,
            width: "780px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: "搜索GRI编码或名称", clearable: "" },
                  on: { clear: _vm.getTemplateList },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.getTemplateList.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.griCode,
                    callback: function ($$v) {
                      _vm.griCode = $$v
                    },
                    expression: "griCode",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-input__icon el-icon-search",
                    attrs: { slot: "prefix" },
                    slot: "prefix",
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "5px",
                display: "flex",
                "flex-wrap": "wrap",
                "max-height": "550px",
                overflow: "auto",
              },
            },
            _vm._l(_vm.itemList, function (item) {
              return _c(
                "div",
                {
                  staticClass: "list__item",
                  class: {
                    selected: item.tplId === _vm.selectedTemplate.tplId,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.selectItem(item)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "flex-start",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "min-width": "50px",
                            "text-align": "center",
                            background: "#ECF2FF",
                            border: "1px solid #D9E6FF",
                            "font-size": "12px",
                            color: "#408EFF",
                            padding: "1px 5px",
                            "border-radius": "5px",
                          },
                        },
                        [_vm._v(_vm._s(item.griCode))]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-left": "10px",
                            color: "#303133",
                            "font-weight": "bold",
                          },
                        },
                        [_vm._v(_vm._s(item.griName))]
                      ),
                    ]
                  ),
                  _c("div", { staticStyle: { "margin-top": "15px" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                        },
                      },
                      [
                        _c("div", { staticStyle: { color: "#909399" } }, [
                          _vm._v("Category2:"),
                        ]),
                        _c("div", { staticStyle: { color: "#606266" } }, [
                          _vm._v(_vm._s(item.category2Name)),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-top": "5px",
                          display: "flex",
                          "justify-content": "space-between",
                        },
                      },
                      [
                        _c("div", { staticStyle: { color: "#909399" } }, [
                          _vm._v("Category3:"),
                        ]),
                        _c("div", { staticStyle: { color: "#606266" } }, [
                          _vm._v(_vm._s(item.category3Name)),
                        ]),
                      ]
                    ),
                  ]),
                  _c("el-divider"),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "font-size": "12px",
                        color: "#909399",
                      },
                    },
                    [
                      _c("div", [
                        _vm._v(_vm._s(item.processCount) + " 个制成"),
                      ]),
                      _c("div", [_vm._v(_vm._s(item.paramCount) + " 个参数")]),
                    ]
                  ),
                  _c("el-divider"),
                  _c(
                    "div",
                    { staticStyle: { "font-size": "12px", color: "#A9AEB8" } },
                    [_vm._v(_vm._s(item.comments))]
                  ),
                ],
                1
              )
            }),
            0
          ),
          _c("el-divider"),
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "flex-end" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.confirmSelect },
                },
                [_vm._v("确认选择")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量导入监控记录",
            visible: _vm.importDialogVisible,
            width: "800px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.importDialogVisible = $event
            },
          },
        },
        [
          _c("batchDialog", {
            attrs: { batchType: "L" },
            on: {
              onUploadSuccess: _vm.onUploadSuccess,
              cancelImport: _vm.cancelImport,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }